module.exports = __webpack_public_path__ + "img/right_quotation_mark.fab4ff6c.svg";